<div class="main_body">
  <div class="pwa-desktop d-flex flex-column align-items-center">
    <img src="assets/img/pwa/hn-logo.svg" alt="">
    <img src="assets/img/pwa/pc-error.svg" alt="">
    <h3>
      ورژن دسکتاپ همراه نوین فعلا در دسترس نیست
      <br/>
      لطفا همراه نوین را در گوشی خود باز کنید
    </h3>
    <img src="assets/img/Dynamic group.svg" alt="">
    <!-- <img src="assets/img/ENBANK.svg" alt=""> -->

  </div>
</div>
